module.exports = __webpack_public_path__ + "img/personalizzazione.png";